import { useParams } from "react-router-dom";
import { useEventDetails } from "../../api/event/queryHooks";
import { decodeId, formatDate, get_media_url } from "../../api/utils";

const EventDetail = ({ data }) => {
  return (
    <div className="truncate">
      <h3>{data.name}</h3>
      <p className="truncate text-[10px]">
        {data.city}, {data.country}
      </p>
      <p className="truncate text-[10px]">
        {formatDate(data.date)} •{" "}
        {/* {data.status === "1" ? "Open Event" : "Closed Event"} • 8 Player • Grass
        Hardcore */}
        {data.status === "1" ? "Open Event" : "Closed Event"} • {data.info}
      </p>
    </div>
  );
};

const EventCard = () => {
  const id = decodeId(useParams()?.id);
  const { data, isLoading } = useEventDetails(id);

  if (isLoading)
    return (
      <div>
        <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative w-full skeleton"></div>
      </div>
    );

  return (
    <>
      <div>
        <div className="h-[210px] sm:h-[320px] md:h-[420px] lg:h-[30vh] relative">
          <img
            className="w-full h-full object-cover"
            src={get_media_url(data.data.banner_img)}
            alt="eventbanner"
          />
          <div
            className="absolute bottom-0 bg-black h-[100px] w-full bg-gradient-to-t"
            style={{
              background: "linear-gradient(to top, #00000099, #00000000)",
            }}
          ></div>
          <div className="absolute bottom-2 w-full px-5">
            <EventDetail data={data.data} />
          </div>
        </div>
      </div>
    </>
  );
};

export default EventCard;
